import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { HmAuthComponent } from './hm-auth.component';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HmLoginComponent } from './hm-login/hm-login-component';
import { HmLogoutComponent } from './hm-logout/hm-logout-component';
import { HmResetPasswordComponent } from './hm-reset-password/hm-reset-password-component';
import { HmRequestPasswordComponent } from './hm-request-password/hm-request-password-component';

import { FormsModule } from '@angular/forms';
import { NbLayoutModule, NbCardModule, NbCheckboxModule } from '@nebular/theme';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NbAuthModule } from '@nebular/auth';

import { HmAssistenzaComponent } from './hm-assistenza/hm-assistenza-component';
import { MODULES_NB } from '@hm_app/@core/utils/nb_modules';
import { MoodleAuthComponent } from './moodle-auth/moodle-auth.component';
import { SharedModule } from '@hm_app/shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HmUpdateProfileComponent } from './hm-update-profile/hm-update-profile.component';

@NgModule({
    imports: [
        ...MODULES_NB,
        CommonModule,
        NbAuthModule,
        NbLayoutModule,
        NbCardModule,
        NbCheckboxModule,
        FormsModule,
        HttpClientModule,
        RouterModule,
        SharedModule,
        NgxSpinnerModule
    ],
    declarations: [
        HmAuthComponent,
        HmLoginComponent,
        HmLogoutComponent,
        HmResetPasswordComponent,
        HmRequestPasswordComponent,
        HmAssistenzaComponent,
        MoodleAuthComponent,
        HmUpdateProfileComponent
    ],
    exports: [RouterModule],
    providers: [HappyMammaService],
})
export class HmAuthModule {

}
